import { createEntityAdapter } from '@reduxjs/toolkit';

export const adapter = createEntityAdapter({});

export const {
  selectById: selectUserById,
  selectIds: selectUserIds,
  selectAll: selectAllUser,
} = adapter.getSelectors();
